 import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CEILING_FITTING_MAX_HEIGHT_MM, ITEM_MODE_NO } from '../../Constants';
import { GradeMasterCollection, MasterItemCollection } from '../../collection';

// 下がり天井の下げ寸法（ceiling_hang_height）の上限(mm)。高さ調整の入力では -1000 が下限になる
const CEILING_HANG_MAX_HEIGHT_MM: number = 1000;

// 高さ調整（正で天井を上げる）と ceiling_hang_height（正で下げる）は符号が逆なので変換する
// 0 は -0 にせず 0 のまま返す（入力欄に「-0」と出さないため）
const invertHangSign = (value: number): number => (value === 0 ? 0 : -value);

// 高さ調整の入力欄の id
const HANG_INPUT_ELEMENT_ID: string = 'roomCeilingHangHeight';

// 基準天井高さの入力欄の id
const BASIC_HEIGHT_INPUT_ELEMENT_ID: string = 'floorCeilingHeight';

// 警告（showAlert）のダイアログの id（core/view/Alert.ts と同じ）
const ALERT_DIALOG_ELEMENT_ID: string = 'alertDialog';

export default class RoomSetting extends Dialog {
    targetRooms: marietta.webcad.item.Room[] = [];
    targetRoom: marietta.webcad.item.Room = null;

    initDone: boolean = false; // 初期化完了

    private basicHeight:number;
  　private maxFloorHeight:number;
    // ダイアログを開いたときの基準天井高さ（変更されたときだけ上限チェックするため）
    private initialBasicHeight:number;
    // ダイアログを開いたときの高さ（下げ寸法）。変更されたときだけ変更後天井高さをチェックするため
    private initialHangHeight:number;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      this.targetRooms= [];
      this.initDone = false;
    }

    /**
     * コンテンツ作成
     */
    buildContent() {
      // ダイアログのコンテンツ生成
      const id = 'roomSettingDialog';
      let title = '梁高さ設定';

      this.targetRoom = this.targetRooms[0];

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Drop Ceiling'; break;
        default: title = '部屋設定'; break;
      }

      // let wallArea = 0;
      // // let habakiArea = 0;
      // let habakiLength = 0;
      // const floorInfo = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeightOfFloor(this.targetRoom.itemInfo.floor);
      // for (let i = 0; i < this.targetRoom.wallObjList.length; i += 1) {
      //   const wall = this.targetRoom.wallObjList[i];
      //
      //   // 開口は、含めない
      //   if (wall.wallType === 0) {
      //     continue;
      //   }
      //
      //   const fittingItemList = [];
      //   fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(wall.parentObj.itemInfo.floor, ITEM_MODE_NO.MODE_FITTING_NO)).getAllChildren());
      //   fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(wall.parentObj.itemInfo.floor, ITEM_MODE_NO.MODE_FITTINGDOWN1_NO)).getAllChildren());
      //
      //   //重なっている建具の面積を集計
      //   let fittingArea = 0;
      //   for (let k = 0; k < fittingItemList.length; k += 1) {
      //     if (!wall.hasOwnProperty('_startDot')) {
      //       console.warn('見積リスト生成で、startDotが未定義です。処理を見直してください');
      //       continue;
      //     }
      //     const beneathList:marietta.webcad.item.parts.Wall[] = fittingItemList[k].getWallsBeneath();
      //     // console.log(fittingItemList[k]);
      //     // console.log(fittingItemList[k].getWallsBeneath());
      //     for (let n = 0; n < beneathList.length; n += 1) {
      //       if (beneathList[n].startDot.guid === wall.startDot.guid) {
      //         fittingArea += fittingItemList[k].itemInfo.area;
      //       }
      //     }
      //   }
      //
      //   const hasHabaki:boolean = marietta.webcad.WebCADGlobal.isRoomWithHabaki(wall.parentObj.itemInfo.id);
      //   const habakiH:number = hasHabaki ? 50 : 0;
      //
      //   const width = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(wall.startDot.point, wall.endDot.point)));
      //   const height = floorInfo.ceilingHeight - floorInfo.floorHeight - habakiH - wall.parentObj.itemInfo.ceiling_hang_height;
      //   wallArea += parseFloat((parseFloat(((width / 1000) * (height / 1000)).toFixed(2)) - fittingArea).toFixed(3));
      //   habakiLength += parseFloat((parseFloat(((width / 1000)).toFixed(2))).toFixed(3));
      // }

      // const floorArea = parseFloat(marietta.webcad.util.WebCADUtil.calculateArea(this.targetRoom.itemInfo.dotList).toFixed(2));
      // const ceilingArea = parseFloat(marietta.webcad.util.WebCADUtil.calculateArea(this.targetRoom.itemInfo.dotList).toFixed(2));

      //見積一覧より取得するように変更
      const floorArea = parseFloat(marietta.webcad.WebCADGlobal.quotationItemList.tableDataFloor.filter( item => -1 < item.guid.indexOf( this.targetRoom.itemInfo.guid) )[0].area);
      const ceilingArea = parseFloat(marietta.webcad.WebCADGlobal.quotationItemList.tableDataCeiling.filter( item => -1 < item.guid.indexOf( this.targetRoom.itemInfo.guid) )[0].area);

      let wallArea = 0;
      let habakiLength = 0;
      marietta.webcad.WebCADGlobal.quotationItemList.tableDataWall.filter( item => item.item === this.targetRoom ).forEach( item => {
        if( item.isHabaki ){
          habakiLength += parseFloat(item.area);
        }else{
          wallArea += parseFloat(item.area);
        }
      });


      // シェアモードではOK・キャンセルを生成せず、入力は無効化して閲覧のみとする
      // 仕上げの選択（チェックボックス・仕上げ全選択）はレイアウトを保つため生成し、SCSS側で非表示にする
      const isShareMode: boolean = marietta.webcad.WebCADGlobal.shareModeManager.isShareMode;
      const disabledAttribute: string = isShareMode ? ' disabled' : '';

      let contents = '<div class="dialogRoomSetting">\n';
      contents += '<div class="areaInfoContainer">\n';

      contents += '<div>\n';
      contents += `<span class="categoryTitle">仕上げ</span>`;
      contents += '<span class="gradeSelectionTitle">仕上げ全選択</span><span class="gradeCheckbox"><input type="checkbox" class="gradeCheckbox" id="roomGradeSelectionCheckbox"></span>';
      contents += '</div>\n';

      // 面積の右揃えを崩さないよう、仕上げのチェックボックスは生成したまま
      // シェアモード時はSCSS側で領域を保って非表示にする
      contents += '<div class="wallAreaWrap">\n';
      contents += '<input type="checkbox" id="roomGradeSelectionCheckbox_wall" class="areaTypeCheck">';
      contents += `<span class="areaTypeTitle">　壁</span><span class="areaTitle">合計：</span><span class="areaValue">${this.targetRooms.length==1?wallArea.toFixed(3):'-'}㎡</span>`;
      contents += '</div>\n';
      contents += '<div class="floorAreaWrap">\n';
      contents += '<input type="checkbox" id="roomGradeSelectionCheckbox_floor" class="areaTypeCheck">';
      contents += `<span class="areaTypeTitle">　床</span><span class="areaTitle">合計：</span><span class="areaValue">${this.targetRooms.length==1?floorArea.toFixed(3):'-'}㎡</span>`;
      contents += '</div>\n';
      contents += '<div class="ceilingAreaWrap">\n';
      contents += '<input type="checkbox" id="roomGradeSelectionCheckbox_ceiling" class="areaTypeCheck">';
      contents += `<span class="areaTypeTitle">天井</span><span class="areaTitle">合計：</span><span class="areaValue">${this.targetRooms.length==1?ceilingArea.toFixed(3):'-'}㎡</span>`;
      contents += '</div>\n';
      contents += '<div class="habakiAreaWrap">\n';
      contents += '<input type="checkbox" id="roomGradeSelectionCheckbox_habaki" class="areaTypeCheck">';
      contents += `<span class="areaTypeTitle">巾木</span><span class="areaTitle">合計：</span><span class="areaValue">${this.targetRooms.length==1?habakiLength.toFixed(3):'-'}m</span>`;
      contents += '</div>\n';
      contents += '</div>\n';
      contents += '<table>\n';
      contents += '<tbody>\n';

      contents += '<table id="roomSettingGroup">\n';
      contents += '<tbody>\n';

      // 設計高さは文字列で返ることがあり、そのまま足すと文字列の連結になるので数値に直す
      this.basicHeight = Number(marietta.webcad.view.dialog.RoomSetting.getBasicCeilingHeight( marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor ));
      this.maxFloorHeight = marietta.webcad.view.dialog.RoomSetting.getMaxFloorHeight( marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor );
      this.initialBasicHeight = parseInt(String(this.basicHeight), 10);

      contents += '<tr>\n';
      contents += '<th>\n<label><span class="jp">基準天井高さ</span><span class="en">Basic Height</span></label></th>\n';
      // contents += `<td>${this.basicHeight} mm</td>\n`;

      contents += '<td><input type="number" min="1000" max="' + this.maxFloorHeight.toString(10) + '" value="' + this.basicHeight.toString() +'" name="floorCeilingHeight" id="floorCeilingHeight"' + disabledAttribute + '> mm</td>\n';
      contents += '</tr>\n';

      contents += '<tr id="roomSettingGroupRow">\n';
      contents += '<th>\n<label for="' + HANG_INPUT_ELEMENT_ID + '"><span class="jp">高さ調整</span><span class="en">Height Adjustment</span></label></th>\n';
      contents += '<td><input type="number" min="' + invertHangSign(CEILING_HANG_MAX_HEIGHT_MM).toString(10) + '" name="' + HANG_INPUT_ELEMENT_ID + '" id="' + HANG_INPUT_ELEMENT_ID + '"' + disabledAttribute + '> mm</td>\n';
      contents += '</tr>\n';

      contents += '<tr>\n';
      contents += '<th>\n<label><span class="jp">変更後天井高さ</span><span class="en">Basic Height</span></label></th>\n';
      contents += `<td id="indicationCeilingHeight">${this.basicHeight-(this.targetRoom.itemInfo.ceiling_hang_height?this.targetRoom.itemInfo.ceiling_hang_height:0)} mm</td>\n`;
      contents += '</tr>\n';

      contents += '<tr>\n';
      contents += '<th>\n<label><span class="jp">巾木高さ</span><span class="en">Habaki Height</span></label></th>\n';
      contents += '<td><input type="number" min="0" max="200" value="' + this.targetRoom.itemInfo.habaki_height.toString() +'" name="roomHabakiHeight" id="roomHabakiHeight"' + disabledAttribute + '> mm</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';

      contents += '</tbody>\n';
      contents += '</table>\n';

      let footer = '';
      if (!isShareMode) {
        footer = '<button id="btnDoneRoomSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
        footer += '<button id="btnCancelRoomSetting"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      }

      this.createDialog(id, title, contents, footer);
      // 高さ調整は max が無く自然な幅が決まらないため、本番で同じ桁数だった基準天井高さの欄の幅に合わせる
      const hangInput: HTMLInputElement = document.getElementById(HANG_INPUT_ELEMENT_ID) as HTMLInputElement;
      hangInput.style.width = getComputedStyle(document.getElementById(BASIC_HEIGHT_INPUT_ELEMENT_ID)).width;
      if (!isShareMode) {
        // イベント設定
        (<HTMLButtonElement>document.getElementById('btnDoneRoomSetting')).addEventListener('click', this.updateRoom);
        this.setInputFilter([document.getElementById('btnDoneRoomSetting')], (value) => /^-?\d*[.,]?\d*$/.test(value));
        // イベント設定
        (<HTMLButtonElement>document.getElementById('btnCancelRoomSetting')).addEventListener('click', this.close);
      }
      this.initialHangHeight = this.targetRoom.itemInfo.ceiling_hang_height ? this.targetRoom.itemInfo.ceiling_hang_height : 0;
      (<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).value = invertHangSign(this.initialHangHeight).toString();

      (<HTMLInputElement>document.getElementById('floorCeilingHeight')).addEventListener('change', ()=>{
        this.updateCeilingHeight();
      });
      (<HTMLInputElement>document.getElementById('floorCeilingHeight')).addEventListener('keyup', ()=>{
        this.updateCeilingHeight();
      });


      (<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).addEventListener('change', ()=>{
        this.updateHeight();
      });
      (<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).addEventListener('keyup', ()=>{
        this.updateHeight();
      });

      if (!isShareMode) {
        (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox')).addEventListener('change', this.onCheckboxClicked);
        (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox_wall')).addEventListener('change', this.onCheckboxClicked);
        (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox_floor')).addEventListener('change', this.onCheckboxClicked);
        (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox_ceiling')).addEventListener('change', this.onCheckboxClicked);
        (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox_habaki')).addEventListener('change', this.onCheckboxClicked);
      }


      const input:HTMLInputElement = document.getElementById("roomHabakiHeight") as HTMLInputElement;
      input.addEventListener( 'change', () => {
        const min:number = 0;
        const max:number = 200;

        if ( parseInt(input.value) < min || isNaN(parseInt(input.value))) input.value = min.toString(10);
        if ( parseInt(input.value) > max) input.value = max.toString(10);
      });
    }

  /**
   * チェックボックスがクリックされた
   */
  onCheckboxClicked = ( e:MouseEvent ) => {
    const target = <HTMLInputElement>e.target;

    if(target == (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox'))){
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_wall")).checked = (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox')).checked;
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_floor")).checked = (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox')).checked;
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_ceiling")).checked = (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox')).checked;
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_habaki")).checked = (<HTMLInputElement>document.getElementById('roomGradeSelectionCheckbox')).checked;
    }

    //見積もり一覧のチェック
    marietta.webcad.WebCADGlobal.quotationItemList.checkTargetRoomParts(this.targetRooms,
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_wall")).checked,
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_floor")).checked,
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_ceiling")).checked,
      (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_habaki")).checked);

    if (!target.checked) return;

    const dialog:marietta.webcad.view.dialog.GradeTypeSelectDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.GradeTypeSelectDialog, false, false, false, false, {updateAllGrade:false}) as marietta.webcad.view.dialog.GradeTypeSelectDialog;
    dialog.callBack = ( grade:GradeMasterCollection, list:any[]　) => {
      const p = new Promise((resolve: Function) => {
        // 壁
        let wallEndItemInfo:MasterItemCollection = GradeMasterCollection.getItemInfoForSymbolAndList('wallpaper', list);
        if (wallEndItemInfo) {
          if( (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_wall")).checked ){
            for (let k:number = 0; k < this.targetRoom.itemInfo.dotList.length; k+=1) {
              this.targetRoom.itemInfo.dotList[k].inner_end_item_info = wallEndItemInfo;
              marietta.webcad.WebCADGlobal.itemManager.updateWallMaterial(this.targetRoom.itemInfo.dotList[k].guid, 0, wallEndItemInfo.symbol_3d_code );
            }
          }
          // 天井
          if( (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_ceiling")).checked ){
            this.targetRoom.itemInfo.ceiling_end_item_info = wallEndItemInfo;
            this.targetRoom.itemInfo.material.ceiling = wallEndItemInfo.symbol_3d_code;
          }
        }

        // 床
        if( (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_floor")).checked ){
          let endItemInfo :MasterItemCollection = GradeMasterCollection.getItemInfoForSymbolAndList('flooring', list);
          if (endItemInfo) {
            this.targetRoom.itemInfo.floor_end_item_info = endItemInfo;
            this.targetRoom.itemInfo.material.floor = endItemInfo.symbol_3d_code;
          }
        }

        for (let room of this.targetRooms) {
          room.overlayText.update()
        }

        // 見積リストの更新
        marietta.webcad.WebCADGlobal.quotationItemList.flushNow();
        marietta.webcad.WebCADGlobal.quotationItemList.checkTargetRoomParts(this.targetRooms,
          (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_wall")).checked,
          (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_floor")).checked,
          (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_ceiling")).checked,
          (<HTMLInputElement>document.getElementById("roomGradeSelectionCheckbox_habaki")).checked);
        this.close();
      });
      p.then(() => {

      });
    };
  }


  /**
   * 基本天井高さの取得
   */
  static getBasicCeilingHeight( targetFloor:number ):number{
    const height:any = marietta.webcad.WebCADGlobal.autoMain.GetDesignHigh();
    switch (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
      case 1: return height.A1; break;
      case 2: return height.B1; break;
      default:
      case 3: return height.C1; break;
    }
  }
  /**
   * 高さ制限の取得
   * 階によらず固定値を返す（引数は呼び出し側との互換のため残している）
   */
  static getMaxFloorHeight( targetFloor:number ):number{
    return CEILING_FITTING_MAX_HEIGHT_MM;
  }

  /**
   * ダイアログを閉じる。警告を出している間は閉じない
   * 警告中の背景クリックで currentDialog（このダイアログ）だけが閉じ、警告が取り残されるため
   */
  public closeEvent(): void {
    if (document.getElementById(ALERT_DIALOG_ELEMENT_ID)) return;
    super.closeEvent();
  }

  /**
   * 高さの反映
   */
  updateHeight = () => {
    let inputValue:number = parseInt((<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).value);
    if( isNaN(inputValue)) inputValue = 0;
    (<HTMLElement>document.getElementById('indicationCeilingHeight')).innerText = `${this.basicHeight+inputValue} mm`;

  }

  /**
   * 高さの反映
   */
  updateCeilingHeight = () => {
    let hangValue:number = parseInt((<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).value);
    if( isNaN(hangValue)) hangValue = 0;

    let inputValue:number = parseInt((<HTMLInputElement>document.getElementById('floorCeilingHeight')).value);
    if( isNaN(inputValue) ) inputValue = 1000;
    this.basicHeight = inputValue;
    (<HTMLElement>document.getElementById('indicationCeilingHeight')).innerText = `${this.basicHeight+hangValue} mm`;
  }

    /**
     * 下がり天井設定の反映
     */
     updateRoom = () => {
       // 入力チェック
       // 高さ調整の入力を ceiling_hang_height の向き（正で下げる）に直し、以降のチェックと保存に使う
       const value:number = invertHangSign(parseFloat((<HTMLInputElement>document.getElementById(HANG_INPUT_ELEMENT_ID)).value));
       const valueFloorHeight:number = parseInt((<HTMLInputElement>document.getElementById('floorCeilingHeight')).value);
       const valueHabakiHeight:number = parseInt((<HTMLInputElement>document.getElementById('roomHabakiHeight')).value);
       // if (value === null || Number.isNaN(value) || valueFloorHeight === null || Number.isNaN(valueFloorHeight) || valueHabakiHeight === null || Number.isNaN(valueHabakiHeight)) {
       if (value === null || Number.isNaN(value) || valueFloorHeight === null || Number.isNaN(valueFloorHeight) ) {
         marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ROOMSETTING_NO_ROOMHEIGHT'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       // 負の値（天井を上げる）は、変更後天井高さが上限以下になる範囲まで。既存の値を触らずに保存できるよう、変更時だけチェックする
       const isHeightChanged:boolean = value !== this.initialHangHeight || valueFloorHeight !== this.initialBasicHeight;
       const isOverCeilingMax:boolean = value < 0 && isHeightChanged && valueFloorHeight - value > this.maxFloorHeight;
       if (value > CEILING_HANG_MAX_HEIGHT_MM || isOverCeilingMax) {
         marietta.webcad.WebCADGlobal.showAlert((marietta.webcad.WebCADGlobal.language === 'jp')
           ? `高さ調整には${invertHangSign(CEILING_HANG_MAX_HEIGHT_MM)}mm以上で、変更後天井高さが${this.maxFloorHeight}mm以下になる数値を入力してください。`
           : `Please input ${invertHangSign(CEILING_HANG_MAX_HEIGHT_MM)}mm or more for the height adjustment, so that the changed ceiling height is ${this.maxFloorHeight}mm or less.`,
           marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       // if (valueHabakiHeight < 0 || valueHabakiHeight > 1000) {
       //   marietta.webcad.WebCADGlobal.showAlert((marietta.webcad.WebCADGlobal.language === 'jp') ? '巾木高さには0mm以上、100mm以下の数値を入力してください。' : 'Please input from 10mm to 100mm for the habaki height.',
       //     marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
       //   return;
       // }
       // 既存プランの上限超えの値を触らずに保存できるよう、変更時だけチェックする
       const isFloorHeightChanged:boolean = valueFloorHeight !== this.initialBasicHeight;
       if (isFloorHeightChanged && (valueFloorHeight < 1000 || valueFloorHeight > this.maxFloorHeight)) {
         marietta.webcad.WebCADGlobal.showAlert((marietta.webcad.WebCADGlobal.language === 'jp') ? `基準天井高さには1000mm以上、${this.maxFloorHeight}mm以下の数値を入力してください。` : `Please input from 10mm to ${this.maxFloorHeight}mm for the basic ceiling height.`,
           marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
         return;
       }
       //階高さの設定
       switch (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor){
         case 1:
           marietta.webcad.WebCADGlobal.autoMain.autoData.Model.SetCeiling1(valueFloorHeight);
           break;
         case 2:
           marietta.webcad.WebCADGlobal.autoMain.autoData.Model.SetCeiling2(valueFloorHeight);
           break;
         case 3:
           marietta.webcad.WebCADGlobal.autoMain.autoData.Model.SetCeiling3(valueFloorHeight);
           break;
       }
       marietta.webcad.WebCADGlobal.changeHeightMenu.setModelParamXMLfrom2D();

       for (let room of this.targetRooms) {
         room.itemInfo.ceiling_hang_height = value;
         room.overlayText.update();
         room.itemInfo.habaki_height = valueHabakiHeight;
       }
       // 天井高さが変わった部屋の UB を合わせ、仕様情報とフッターに出す（この操作は履歴を積まない）
       marietta.webcad.WebCADGlobal.webcad2Dmanager.commitWithoutHistory();

       //全部屋のテキスト更新
       let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
       itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
       itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
       for (let room of itemList) {
         room.overlayText.update();
       }

       // ダイアログを閉じる
       this.close();
     }

      setInputFilter= (textbox, inputFilter) => {
        ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach((event) => {
          for (let i = 0; i < textbox.length; i += 1) {
            (<HTMLInputElement>textbox[i]).addEventListener(event, function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
                // eslint-disable-next-line no-prototype-builtins
              } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
              }
            });
          }
        });
      }
}
